import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  jobId: string
}

const mutateRunJob = async ({ jobId, communityId }: mutateProps) => {
  return await axiosAuth.post(
    `${DISTRIBUTION_JOBS_API(communityId)}/${jobId}/run`,
  );
};

const useRunJobMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateRunJob,
    ...queryParams,
  });

export default useRunJobMutation;
